export var RefundStatus;

(function (RefundStatus) {
  RefundStatus["CHANGE"] = "CHANGE";
  RefundStatus["PROCESSING"] = "PROCESSING";
  RefundStatus["REFUNDCLOSE"] = "REFUNDCLOSE";
  RefundStatus["SUCCESS"] = "SUCCESS";
  RefundStatus["TO_BE_REFUND"] = "TO_BE_REFUND";
})(RefundStatus || (RefundStatus = {}));

export var RefundsOrderBy = {
  createdAt: 'CREATED_AT',
  refundNumber: 'REFUND_NUMBER',
  status: 'STATUS',
  totalAmount: 'TOTAL_AMOUNT',
  totalPrice: 'TOTAL_PRICE',
  transactionNumber: 'TRANSACTION_NUMBER',
  updatedAt: 'UPDATED_AT',
  auditStatus: 'AUDIT_STATUS'
};
var RefundType;

(function (RefundType) {
  RefundType[RefundType["RETURN_THE_WAY_COME"] = 0] = "RETURN_THE_WAY_COME";
})(RefundType || (RefundType = {}));

var RefundAccount;

(function (RefundAccount) {
  RefundAccount[RefundAccount["REFUND_SOURCE_RECHARGE_FUNDS"] = 0] = "REFUND_SOURCE_RECHARGE_FUNDS";
  RefundAccount[RefundAccount["REFUND_SOURCE_UNSETTLED_FUNDS"] = 1] = "REFUND_SOURCE_UNSETTLED_FUNDS";
})(RefundAccount || (RefundAccount = {}));